export default __webpack_public_path__ + "static/media/blue_blur_background.c0683984.jpg";